var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04163 8.8333H3.95829V2.3333L0.979128 5.31246L0.209961 4.5433L4.49996 0.253296L8.78996 4.5433L8.02079 5.31246L5.04163 2.3333V8.8333Z",
    fill: "#34C38F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/green_arrow.46be50f4c3b5f6471741c6a75f086777.svg";
export { ForwardRef as ReactComponent };